import http from "./httpService";
const apiEndpoint = process.env.REACT_APP_API_IDENTITY_URL + "/ModuleAccess";

export async function moduleAccess(data) {
  http.addBearerAuthorization();
    return await http.post(apiEndpoint, data);
  }

  export async function moduleAccessData(data) {
    http.addBearerAuthorization();
      return await http.post(`${apiEndpoint}/export`, data);
    }
  export async function getModules() {
    http.addBearerAuthorization();
      return await http.get(apiEndpoint);
    }
  export async function getModuleById(id) {
    http.addBearerAuthorization();
      return await http.get(`${apiEndpoint}?moduleId=${id}`);
    }
  export async function updateModules(req) {
    http.addBearerAuthorization();
      return await http.post(`${apiEndpoint}/UpdateModule`, req);
    }
  export default {
      moduleAccess,
      moduleAccessData,
      getModules,
      updateModules,
      getModuleById
  }